import http from 'hub-http/clients/apiClient';
import { registerMutation, useMutation } from 'data-fetching-client';
import { convertInternalViewToBEFormat, transformBackendViewToInternalFormat } from '../../viewsSearch/dataOperators/backendViews';
import { SingleViewByIdQuery } from './useFetchSingleView';
import { VIEWS_SEARCH_QUERY_NAME } from '../../viewsSearch/hooks/useFetchViewsSearch';
const UPDATE_SINGLE_VIEW_MUTATION_NAME = 'updateSingleView';
const createViewMutationArgsArgument = ['objectTypeId', 'name', 'type', 'state', 'teamId', 'ownerId', 'private', 'id', 'columns', 'namespaceName'];
export const UpdateSingleViewMutation = registerMutation({
  fieldName: UPDATE_SINGLE_VIEW_MUTATION_NAME,
  args: createViewMutationArgsArgument,
  fetcher: args => http.put(`/sales/v4/views/${encodeURIComponent(args.id)}?namespace=${args.namespaceName}`, {
    data: convertInternalViewToBEFormat(args)
  }).then(response => {
    return transformBackendViewToInternalFormat(response);
  })
});
export const useUpdateSingleViewByIdMutation = ({
  view
}) => {
  const variables = {
    id: view.id,
    objectTypeId: view.objectTypeId,
    namespaceName: view.namespaceName
  };
  return useMutation(UpdateSingleViewMutation, {
    variables: view,
    refetchQueries: [VIEWS_SEARCH_QUERY_NAME, {
      query: SingleViewByIdQuery,
      variables
    }],
    //From apollo docs: "If true, makes sure all queries included in refetchQueries are completed before the mutation is considered complete."
    //This is important because the backend will return stale data unless we wait for the put request to complete
    awaitRefetchQueries: true
  });
};